module.exports = __webpack_public_path__ + "ga.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/ga.svg
// module id = 553
// module chunks = 0